export const SESSION_ROUTE_SEGMENTS = {
  forbidden: '403',
  notFound: '404',
  internalServerError: '500',
  serviceUnavailable: '503',
} as const;

export const SESSIONS_PATHS = {
  forbidden: `/sessions/${SESSION_ROUTE_SEGMENTS.forbidden}`,
  notFound: `/sessions/${SESSION_ROUTE_SEGMENTS.notFound}`,
  internalServerError: `/sessions/${SESSION_ROUTE_SEGMENTS.internalServerError}`,
  serviceUnavailable: `/sessions/${SESSION_ROUTE_SEGMENTS.serviceUnavailable}`,
} as const;
